import React from "react";

import Typography from "@mui/material/Typography";

import useReportsTable from "@app/analytics/MeetingReports/stores/reportsTable";

import RecurringMeetingBadge from "@rui/RecurringMeetingBadge";
import Switch from "@rui/Switch";
import TooltipWrapper from "@rui/TooltipWrapper";

import { MenuItemContainer } from "./styles";

const GroupReportsToggle = () => {
  const [groupRecurring, setGroupRecurring] = useReportsTable((state) => [
    state.groupRecurring,
    state.setGroupRecurring,
  ]);

  return (
    <MenuItemContainer>
      <RecurringMeetingBadge size="12px" />
      <Typography
        variant="bodySecondaryMed"
        sx={{ display: { xxs: "none", lg: "block" }, ml: 1 }}
      >
        Group
      </Typography>
      <TooltipWrapper title="Group Recurring Meetings">
        <Switch
          checked={groupRecurring}
          onChange={(e) => setGroupRecurring(e.target.checked)}
          sx={{ mr: "2px" }}
        />
      </TooltipWrapper>
    </MenuItemContainer>
  );
};

export default GroupReportsToggle;
